import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'

const data = {
  question:
    'Claims that vaping is safer than smoking cigarettes are misleading to adolescents because _______ is expelled by the user of an e-cigarette, which is toxic and can burn your mouth, throat, and lungs.',
  inputType: 'radio',
  options: [
    {
      label: 'smoke',
    },
    {
      label: 'aerosol',
    },
    {
      label: 'water',
    },
    {
      label: 'vapor',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[1].label,
}

const feedback = {
  success: {
    title: 'That’s right!',
    body:
      'Aerosol is expelled by the user of an e-cigarette, which contains chemicals that are toxic and can burn your mouth, throat, and lungs.',
  },
  error: {
    title: 'Not quite.',
    body:
      'Aerosol is expelled by the user of an e-cigarette, which contains chemicals that are toxic and can burn your mouth, throat, and lungs. You will learn more about this in the module.',
  },
}

export default {
  title: 'Question 1',
  path: '/prepare/question-1',
  content: (
    <Fragment>
      <Intro
        title="Question 1"
        direction={'Select the item that best completes the statement.'}
      />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/Question1.js